import UploadFileIcon from "@mui/icons-material/UploadFile";
import Button, { type ButtonProps } from "@mui/material/Button";

export type CsvImportTriggerButtonProps = {
  label: string;
  onClick: () => void;
  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
};

/** List-toolbar button that opens a CSV import dialog. */
export default function CsvImportTriggerButton({
  label,
  onClick,
  size = "small",
  variant = "outlined",
}: CsvImportTriggerButtonProps) {
  return (
    <Button startIcon={<UploadFileIcon />} onClick={onClick} size={size} variant={variant}>
      {label}
    </Button>
  );
}
